import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import BlocklyComponent, { Block } from '../Blockly';
import styles from "../styles/level1.module.css"
import instrLink from "../images/level0/instrLink.png"
import level0Task0 from '../solutionxml/level0Task0'

const level0 = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
        Level 0: Hello World 
      </h1>
      <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 0: Use the Blockly Workspace below to print out 'Hello World.' Use the 'Run' button to see the output!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      initialXml={`
<xml xmlns="http://www.w3.org/1999/xhtml">
</xml>
  `}
      solutionXml = {level0Task0}
  >
      <Block type="text_print"></Block>
      <Block type="text"></Block>
      </BlocklyComponent>
  </div>
  </main>
  </div>
  );
}
  
export default level0;